import React, { useContext, useEffect, useRef, useState } from "react";
import Profile from "../components/Profile";
import { motion } from "framer-motion";
import { AuthContext } from "./Login";
import { db, storage } from "../firebase-config";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { addDoc, collection, getDocs } from "firebase/firestore";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import { youtubeJourney } from "../helpers/projectListData";
import {
  gridContainterVariants,
  gridCubeVariants,
} from "../utilities/customHooks";
import Shots from "../components/Shots";

function BeyondWork() {
  const { isLogin } = useContext(AuthContext);
  const dialogRef = useRef();
  const [beyondActivity, setBeyondActivity] = useState({
    thumbnail: "",
    title: "",
    tag: "",
    excerpt: "",
    date: "",
    content: "",
  });

  const [beyondWorkData, setBeyondWorkData] = useState([]);
  const navigate = useNavigate();

  const [imagePreview, setImagePreview] = useState(null); // For image preview
  const [file, setFile] = useState(null); // For the selected file
  const [beyond, setBeyond] = useState([]); // Store beyond work data

  const handleTextEditorChange = (value) => {
    setBeyondActivity({
      ...beyondActivity,
      content: value, // Update details with the rich text content
    });
  };

  const handleChange = (e) => {
    setBeyondActivity({
      ...beyondActivity,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setImagePreview(URL.createObjectURL(selectedFile)); // Preview the image
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newEntry = { ...beyondActivity, id: beyondWorkData.length };
    setBeyondWorkData([...beyondWorkData, newEntry]);

    if (file) {
      const storageRef = ref(storage, `images/beyondwork/${file.name}`); // Create a storage reference
      try {
        // Upload file to Firebase Storage
        const snapshot = await uploadBytes(storageRef, file);

        // Get the download URL
        const downloadURL = await getDownloadURL(snapshot.ref);

        // Create the new beyondActivity object with image URL
        const newBeyondActivity = { ...beyondActivity, thumbnail: downloadURL };

        // Use Firestore's addDoc method to add new data
        await addDoc(collection(db, "BeyondWork"), newBeyondActivity); // Adding to Firestore

        // Update local state to display the new data
        setBeyond([...beyond, newBeyondActivity]);

        // Reset the form fields and image preview
        setBeyondActivity({
          thumbnail: "",
          title: "",
          tag: "",
          excerpt: "",
          date: "",
          content: "",
        });
        setFile(null);
        setImagePreview(null);
        dialogRef.current?.close();
      } catch (err) {
        console.error("Error uploading image or saving data", err);
      }
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(db, "BeyondWork")); // Get all documents from beyondWork collection
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBeyond(data); // Set the fetched data to state
    };

    fetchData(); // Call fetch function
  }, []);

  function closeDialog() {
    dialogRef.current?.close();
  }
  return (
    <>
      <dialog ref={dialogRef}>
        <span onClick={closeDialog} className="closeDialog"></span>
        <div className="Popup">
          <h2>Add New Post</h2>
          <form className="form" onSubmit={handleSubmit}>
            <div className="desc-col">
              <div className="desc">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  placeholder="Title"
                  value={beyondActivity.title}
                  onChange={handleChange}
                />
              </div>
              <div className="desc">
                <label>Tag</label>
                <input
                  type="text"
                  name="tag"
                  placeholder="Tag"
                  value={beyondActivity.tag}
                  onChange={handleChange}
                />
              </div>
              <div className="desc">
                <label>Excerpt</label>
                <input
                  type="text"
                  name="excerpt"
                  placeholder="Excerpt"
                  value={beyondActivity.excerpt}
                  onChange={handleChange}
                />
              </div>
              <div className="desc">
                <label>Date</label>
                <input
                  type="date"
                  name="date"
                  placeholder="Date"
                  value={beyondActivity.date}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="desc-col">
              <div className="desc">
                <label>Thumbnail</label>
                <input type="file" onChange={handleImageChange} />
                {imagePreview && <img src={imagePreview} alt="Preview" />}
              </div>
              <div className="desc">
                <label>Description</label>
                <ReactQuill
                  theme="snow"
                  value={beyondActivity.content}
                  onChange={handleTextEditorChange}
                  placeholder="Enter detailed description..."
                />
              </div>
              <button className="submit" type="submit">
                Add New
              </button>
            </div>
          </form>
        </div>
      </dialog>
      <Profile />
      <motion.div
        className="box right"
        variants={gridContainterVariants}
        initial="hidden"
        animate="show"
      >
        <Shots />
        <motion.div variants={gridCubeVariants} className="section">
          <h2>
            🕵️‍♂️ <span>Beyond Work</span>
          </h2>
          <div>
            {isLogin ? (
              <button
                className="addNew"
                onClick={() => dialogRef.current?.showModal()}
              >
                Add New
              </button>
            ) : (
              ""
            )}
          </div>
        </motion.div>
        <div className="section wrap">
          {beyond
            .slice()
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .map((exp, index) => (
              <motion.div
                variants={gridCubeVariants}
                className="beyond1-2"
                key={index}
              >
                {exp.thumbnail && <img src={exp.thumbnail} alt={exp.title} />}
                <h3>
                  {exp.title} <span>{exp.tag}</span>
                </h3>
                <p className="date">{exp.date}</p>
                <p>{exp.excerpt}</p>
                <a
                  className="viewDetail"
                  onClick={() => {
                    navigate(`/beyondwork/${exp.id}`, { state: { exp } });
                  }}
                >
                  View Details
                </a>
              </motion.div>
            ))}
        </div>
        <div className="section">
          <h2>
            🎥 <span>Youtube Journey</span>
          </h2>
        </div>
        <div className="contentParagraph">
          <p>
            I have a deep passion for FIFA and enjoy playing it on my PS5, both
            solo and with friends. Beyond just gaming, I also run a YouTube
            channel where I share content about FIFA, alongside tutorials and
            insights on CSS and 3D design. This channel allows me to combine my
            love for gaming and my expertise in web design, offering a diverse
            range of content for my audience.
          </p>
        </div>
        <div className="section">
          {youtubeJourney.map((journey, i) => {
            return (
              <div className="shot" key={i}>
                <div className="shot-img">
                  <img src={journey.thumbnail} alt="Shot" />
                </div>
                <p>{journey.name}</p>
                <p className="tag">{journey.category}</p>
                <a className="follow" href={journey.channel} target="_blank">
                  Subscribe
                </a>
              </div>
            );
          })}
        </div>
      </motion.div>
    </>
  );
}

export default BeyondWork;
